import Vuex from 'vuex'
import categoriesData from '~/data/categories.json'
import questionsData from '~/data/questions.json'

const getDefaultState = () => {
    return {
        categories: categoriesData,
        questions: questionsData
    }
}

const createStore = () => {
    return new Vuex.Store({
        state () {
            return getDefaultState()
        },
        getters: {
            // categories
            getCategories: (state) => {
                return state.categories
            },
            getCategoryById: state => (id) => {
                return state.categories.find(e => e.id === id)
            },

            getSubcategoryById: state => (id, subId) => {
                const category = state.categories.find(e => e.id === id)
                return category.subcategories.find(e => e.subId === id)
            },

            // questions
            getQuestions: (state) => {
                return state.questions
            },
            getQuestionById: state => (id) => {
                return state.questions.find(e => e.id === id)
            },
            getQuestionByCatId: state => (id) => {
                return state.questions.filter(e => e.category_id === id)
            },
            getQuestionBySubId: state => (id) => {
                return state.questions.filter(e => e.subcategory_id === id)
            }
        },
        mutations: {
        },
        actions: {
        }
    })
}

export default createStore
